import { useState, useEffect, useRef } from 'react';

/**
 * Hook que detecta quando o elemento entra na viewport.
 * Útil para animações ao fazer scroll.
 * @param {Object} options - Opções do IntersectionObserver
 * @param {number} options.threshold - % visível para considerar "in view" (0-1)
 * @param {string} options.rootMargin - Margem do root (ex: "0px 0px -50px 0px")
 * @returns {[React.RefObject, boolean]} [ref, isInView]
 */
export default function useInView(options = {}) {
  const { threshold = 0.15, rootMargin = '0px 0px -50px 0px' } = options;
  const [isInView, setIsInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return [ref, isInView];
}
